// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-003b75d035130520.js";
	if (chunkId === 3859) return "static/chunks/3859-9a4d5024cd684fa2.js";
	if (chunkId === 9617) return "static/chunks/9617-df1523a1720c2b69.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"1dfb2059d430a3a0","2460":"6d52a2113260c511","2648":"b7adfa15e772d767","2823":"e15477ae27a220ef","4654":"95675ecc9c852f83","5192":"4e79879212b5f594","5355":"6ba09c38ca0c6ea5","7247":"fbfb0285f08643ab","8395":"c88269f2cf2e395b","9595":"21a1d0fc264f6d25","9718":"e7ae66de2279a52c"}[chunkId] + ".js";
};